export default {
    onlineWills: {
        titleHK: '網上平安紙服務 | 平安紙律師推薦 | 立平安紙律師費用 | 平安紙平安紙分別',
        descriptionHK: 'NobleWills 是香港網上立平安紙的平台，服務快速，廉宜且值得信賴。 只需2個工作天您便可以收取一份專業平安紙。',
        keywordsHK: '香港網上平安紙, 香港平安紙, 平安紙樣本, 香港網上平安紙, 香港平安紙, 平安紙律師介紹, 平安紙律師推薦, 立平安紙律師費用, 平安紙平安紙分別',
        s: '的',
        online: '網上',
        willWritingService: '訂立平安紙平台',
        heroTitle: '{{location}}的網上平安紙服務 - 為國際生活而設',
        estatePlanning: '輕鬆訂立跨境平安紙，由',
        estatePlanning2: '起。只需要15分鐘，便能建立您的遺產計劃。',
        How: '整個程序如何運作',
        eachStep: '整個流程清晰簡單，讓您可更順暢地完成訂立遺囑，如有需要，我們亦會在過程中提供協助。',
        step1: '註冊並填寫資料',
        step1Body: '註冊帳戶並於平台填寫遺囑資料。如有任何問題，歡迎透過即時對話或 WhatsApp 聯絡我們。',
        step2: '選擇服務計劃',
        step2Body: '選擇適合您的服務計劃並完成付款。',
        step3: '我們審閱遺囑內容',
        step3Body: '我們會為您的遺囑進行內容一致性檢查，並電郵 PDF 版本及簽署指引給您。',
        step4: '安排遺產規劃諮詢',
        step4Body: '如您已選擇遺產規劃諮詢服務，我們將聯絡您安排視像會議。',
        step5: '安排兩位見證人簽署',
        step5Body: '當您確認遺囑內容無誤後，請按照指引安排兩位見證人簽署遺囑。',
        step6: '安排見證簽署服務',
        step6Body: '如您已選擇見證服務，我們將安排於指定地點進行簽署。',
        countrySpecificHeading: '其他國家遺囑',
        countrySpecificIntro: '其他國家遺囑現已採用與網上遺囑相同的流程。部分司法管轄區可直接於平台完成，其餘地區亦可由我們團隊協助辦理。',
        platformCountriesHeading: '可於平台直接辦理',
        platformCountriesBody: '以下司法管轄區可透過您的網上帳戶完成。',
        platformCountriesTableTitle: '平台可辦理的國家/地區',
        offPlatformCountriesHeading: '可於平台外辦理',
        offPlatformCountriesBody: '以下司法管轄區可由我們團隊協助安排，請聯絡我們查詢價格。',
        offPlatformCountriesTableTitle: '平台外可辦理的國家/地區',
        englandAndWales: '英格蘭及威爾斯',

        includedEyebrow: '平安紙內通常包括',
        includedHeading: '平安紙可涵蓋的核心安排',
        includedIntro: '我們會根據您的實際需要，安排誰來管理遺產、誰可受益，以及在不同情況下應如何執行您的意願。',
        includedClausesIntro: '您的平安紙亦會包含常見而重要的標準條款，例如存活條款及免保證金條款。',
        includedClausesLinkText: '按此了解更多標準條款內容。',
        included1Title: '遺囑執行人及受託人',
        included1Body: '委任負責執行您指示的人士，以及管理遺產和遺囑下任何信託安排的人士，並可加入後備執行人。',
        included2Title: '未成年子女監護人',
        included2Body: '為您的子女預先指定永久監護人，以便在需要時由您信任的人接手。',
        included3Title: '現金遺贈',
        included3Body: '向家人、朋友或慈善機構送出固定金額。',
        included4Title: '特定財產遺贈',
        included4Body: '把住宅、投資資產或其他指定財產留給您選擇的人。',
        included5Title: '個人物品遺贈',
        included5Body: '安排珠寶、藝術品、傳家之寶、紀念品及其他個人財物的分配。',
        included6Title: '餘下遺產分配',
        included6Body: '在處理遺贈、債務、開支、稅項及不屬於遺囑的資產後，把餘下遺產分配予主要及後備受益人。',
        included7Title: '未成年受益人信託',
        included7Body: '如受益人未成年，可透過遺囑信託保留其份額，直至他們適合領取為止。',
        included8Title: '喪禮安排及排除條款',
        included8Body: '列明您的喪禮意願，並清楚寫明您希望排除哪些人士不得受益。',
        ourWills: '平安紙',
        ourWillsBody: '遺產計劃不單是一份平安紙，當中還包括其他重要的文件。您可以參考我們的遺產計劃組合。',
        whyUse: '為什麼使用我們的網上服務？',
        whyUseBody: 'NobleWills 的網上平安紙訂立服務除了為您節省時間、金錢，亦能減輕您的壓力，我們的',
        whyUseItem: '流程簡潔，能協助您順暢地完成您的平安紙。',
        whyUseItem2: '平安紙內容全面、價格合理，而且沒有隱形費用。',
        whyUseItem3: '網上平台方便實用、資訊豐富、而且由律師精心設計。可讓您安心地在家中建立您的平安紙。',
        cover: '網上平安紙涵蓋些甚麼？',
        coverBody:
            '您可以選擇平安紙執行人/受託人來管理您的遺產、選擇孩子和寵物的監護人，向家人和朋友分發遺贈，並將您的其餘遺產分配給其他人。甚至可以選擇從遺產中排除某些人並安排您的葬禮。',
        coverBody2: '您還可以選擇提供更多資料以製造願望信、資產清單和數碼資產清單。 這些文件對您的平安紙執行人管理您的遺產時非常有用。',
        howLong: '整個過程需時多久？',
        howLongBody: '填寫您平安紙有關的內容只需15分鐘。',
        howLongBody2: '倘若需要更多時間考慮平安紙的內容，我們的系統將保存您的進度，以便您稍後登入以完成該過程。',
        howLongBody3: '在您提交資料後，我們只需2個工作天，便能完成並電郵遺產規劃的PDF版本給您。 ',
        howLongBody4: '最後一步是很簡單地下載最終文件，然後按照說明簽署和存儲您的平安紙。（升級服務：專業版本會送到你府上）',
        whatLang: '文件是用什麼語言寫的？',
        whatLangBodyHK: '平安紙和隨附文件會以您帳戶所選擇的語言而設。',
        preview: '示範片段',
        previewBody: '以下片段示範了平安紙訂立流程。',
        notSuitable: '',
        premiumService: '',
    },
};
